var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "container"
  }, [_c('Modal', {
    attrs: {
      "title": "修改配方状态"
    },
    on: {
      "on-ok": _vm.changeStatus,
      "on-cancel": _vm.cancel
    },
    model: {
      value: _vm.changeStatusModel,
      callback: function ($$v) {
        _vm.changeStatusModel = $$v;
      },
      expression: "changeStatusModel"
    }
  }, [_c('RadioGroup', {
    model: {
      value: _vm.status,
      callback: function ($$v) {
        _vm.status = $$v;
      },
      expression: "status"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "reviewing"
    }
  }, [_c('span', [_vm._v("审核中")])]), _c('Radio', {
    attrs: {
      "label": "verified"
    }
  }, [_c('span', [_vm._v("通过")])]), _c('Radio', {
    attrs: {
      "label": "rejected"
    }
  }, [_c('span', [_vm._v("拒绝")])]), _c('Radio', {
    attrs: {
      "label": "canceled"
    }
  }, [_c('span', [_vm._v("弃用")])])], 1)], 1), _c('Modal', {
    on: {
      "on-ok": _vm.deleteRecipe
    },
    model: {
      value: _vm.deleteRecipModel,
      callback: function ($$v) {
        _vm.deleteRecipModel = $$v;
      },
      expression: "deleteRecipModel"
    }
  }, [_c('p', [_vm._v("你确定要删除这个配方吗？")])]), _c('div', {
    staticClass: "handle-wrapper"
  }, [_c('Input', {
    staticStyle: {
      "width": "250px",
      "margin-right": "20px"
    },
    attrs: {
      "search": "",
      "placeholder": "搜索客户...",
      "clearable": "",
      "icon": "ios-search"
    },
    on: {
      "on-change": _vm.searchRecipe
    },
    model: {
      value: _vm.searchText,
      callback: function ($$v) {
        _vm.searchText = $$v;
      },
      expression: "searchText"
    }
  }), _c('div', {
    staticStyle: {
      "margin-right": "auto"
    }
  }, [_c('RadioGroup', {
    staticClass: "view-switch",
    attrs: {
      "type": "button"
    },
    on: {
      "on-change": _vm.changeView
    },
    model: {
      value: _vm.view,
      callback: function ($$v) {
        _vm.view = $$v;
      },
      expression: "view"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "list"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "md-menu"
    }
  })], 1), _c('Radio', {
    attrs: {
      "label": "card"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-grid"
    }
  })], 1)], 1)], 1), _c('span', [_vm._v("共" + _vm._s(_vm.totalRows) + "条")]), _c('Page', {
    staticStyle: {
      "margin-right": "24px"
    },
    attrs: {
      "total": _vm.totalRows,
      "page-size": 15,
      "show-total": "",
      "simple": ""
    },
    on: {
      "on-change": _vm.loadRecipe
    }
  }), _vm.currentUser.superAdmin ? _c('Button', {
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.toMaterialSearchAndReplace
    }
  }, [_vm._v("原材料搜查与替换")]) : _vm._e()], 1), _vm.view === 'list' ? _c('div', {
    ref: "tableWrapper",
    staticClass: "table-wrapper"
  }, [_c('Table', {
    attrs: {
      "columns": _vm.columns,
      "data": _vm.tableData,
      "height": _vm.tableHeight
    }
  })], 1) : _vm._e(), _vm.view === 'card' ? _c('div', {
    staticClass: "card-wrapper"
  }, _vm._l(_vm.tableData, function (item) {
    return _c('div', {
      key: item._id,
      staticClass: "card-item",
      attrs: {
        "value": item._id
      }
    }, [_c('Card', {
      staticStyle: {
        "width": "320px"
      }
    }, [_c('div', {
      staticClass: "card-title"
    }, [_c('h3', {
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v(_vm._s(item.customer.name))]), _c('Dropdown', {
      attrs: {
        "trigger": "click"
      },
      on: {
        "on-click": _vm.clickActionDropDown
      }
    }, [_c('Icon', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "type": "ios-more",
        "size": "24"
      }
    }), _c('DropdownMenu', {
      attrs: {
        "slot": "list"
      },
      slot: "list"
    }, [_c('DropdownItem', {
      attrs: {
        "name": `edit ${item._id}`
      }
    }, [_vm._v("编辑配方")]), _c('DropdownItem', {
      attrs: {
        "name": `status ${item._id}`
      }
    }, [_vm._v("修改状态")]), _c('DropdownItem', {
      staticStyle: {
        "color": "#ed4014"
      },
      attrs: {
        "name": `delete ${item._id}`
      }
    }, [_vm._v("删除配方")])], 1)], 1)], 1), _c('div', {
      staticClass: "item"
    }, [_c('div', [_vm._v("配方")]), _c('div', [_vm._v("#" + _vm._s(item.NoId) + " " + _vm._s(item.name))])]), _c('div', {
      staticClass: "item"
    }, [_c('div', [_vm._v("创建人")]), _c('div', [_vm._v(_vm._s(item.createdBy ? item.createdBy.name : ""))])]), _c('div', {
      staticClass: "item"
    }, [_c('div', [_vm._v("审核人")]), _c('div', [_vm._v(_vm._s(item.verifiedBy ? item.verifiedBy.name : ""))])]), _c('div', {
      staticClass: "item"
    }, [_c('div', [_vm._v("状态")]), _c('div', [_vm._v(_vm._s(_vm.cardStatusToText(item.status)))])]), _c('div', {
      staticClass: "item"
    }, [_c('div', [_vm._v("创建时间")]), _c('div', [_vm._v(_vm._s(_vm.formatDate(item.createdAt)))])]), _c('Row', {
      staticClass: "item"
    }, [_c('Col', {
      staticStyle: {
        "text-align": "left"
      },
      attrs: {
        "span": "8"
      }
    }, [_vm._v("材料")]), _c('Col', {
      staticClass: "table-title",
      attrs: {
        "span": "4"
      }
    }, [_vm._v("原配方")]), _c('Col', {
      staticClass: "table-title",
      attrs: {
        "span": "3"
      }
    }, [_vm._v("变化")]), _c('Col', {
      staticClass: "table-title",
      attrs: {
        "span": "5"
      }
    }, [_vm._v("新配方")])], 1), _vm._l(item.allDetail ? item.allDetail : item.detail, function (x) {
      return _c('div', {
        key: x.material._id,
        staticClass: "recipe-row",
        attrs: {
          "value": x.material._id
        }
      }, [_c('RecipeRow', {
        attrs: {
          "field": x.material.model ? x.material.model : x.material.name,
          "value": item,
          "detail": x
        }
      })], 1);
    }), item.status === 'reviewing' ? _c('div', {
      staticClass: "verify-recipe"
    }, [_c('Button', {
      attrs: {
        "type": "success",
        "ghost": ""
      },
      on: {
        "click": function ($event) {
          return _vm.verifiedRecipe({
            id: item._id,
            status: 'verified'
          });
        }
      }
    }, [_vm._v("合格")]), _c('Button', {
      attrs: {
        "type": "error",
        "ghost": ""
      },
      on: {
        "click": function ($event) {
          return _vm.verifiedRecipe({
            id: item._id,
            status: 'rejected'
          });
        }
      }
    }, [_vm._v("不合格")])], 1) : _vm._e()], 2)], 1);
  }), 0) : _vm._e(), _c('RecipeDetailDrawer', {
    ref: "RecipeDetailDrawer"
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }